"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
function formatAccountSpecifics(account) {
    var elrondResources = account.elrondResources;
    (0, invariant_1["default"])(elrondResources, "elrond account expected");
    var unit = (0, account_1.getAccountUnit)(account);
    var formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true
    };
    var str = " ";
    if (account.spendableBalance) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) +
                " spendable. ";
    }
    else {
        str += " 0 spendable.";
    }
    if (elrondResources && elrondResources.nonce) {
        str += "\n nonce : " + elrondResources.nonce;
    }
    return str;
}
function formatOperationSpecifics(_op, _unit) {
    return "";
}
exports["default"] = {
    formatAccountSpecifics: formatAccountSpecifics,
    formatOperationSpecifics: formatOperationSpecifics
};
//# sourceMappingURL=account.js.map